import { AxiosPromise } from 'axios';
import { instance } from '../../../services';

const updateLicense = (license: string): AxiosPromise =>
  instance.put(`/api/settings/license`, license);

export default updateLicense;
